"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/source/State
 */

/**
 * @enum {string}
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */
var _default = {
  UNDEFINED: 'undefined',
  LOADING: 'loading',
  READY: 'ready',
  ERROR: 'error'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7ZUFJZTtFQUNiQSxTQUFTLEVBQUUsV0FERTtFQUViQyxPQUFPLEVBQUUsU0FGSTtFQUdiQyxLQUFLLEVBQUUsT0FITTtFQUliQyxLQUFLLEVBQUU7QUFKTSxDIiwibmFtZXMiOlsiVU5ERUZJTkVEIiwiTE9BRElORyIsIlJFQURZIiwiRVJST1IiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3NvdXJjZS9TdGF0ZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==